import { render, staticRenderFns } from "./EmailRecipients.vue?vue&type=template&id=2448585c&scoped=true"
import script from "./EmailRecipients.vue?vue&type=script&lang=js"
export * from "./EmailRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2448585c",
  null
  
)

export default component.exports